import {StyleSheet} from 'react-native';

import {cloud, onyxLighter, white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    flexDirection: 'row',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: cloud,
    borderRadius: 3,
    paddingVertical: 6,
    paddingHorizontal: 12,
    backgroundColor: white,
  },
  text: {
    color: onyxLighter,
  },
  icon: {
    color: onyxLighter,
    marginLeft: 8,
  },
  badge: {
    width: 18,
    height: 18,
    borderStyle: 'solid',
    borderWidth: 2,
    borderColor: white,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 9999,
    overflow: 'hidden',
    position: 'absolute',
    right: 8,
    top: 3,
  },
  badgeText: {
    color: white,
  },
  disabledContainer: {
    backgroundColor: cloud,
  },
  disabledText: {
    color: white,
  },
  disabledIcon: {
    color: white,
  },
});
